const drag = (dom) => {
  dom.onmousedown = function (ev) {
    const oEvent = ev || event;
    const zuo = oEvent.clientX - dom.offsetLeft;
    const shang = oEvent.clientY - dom.offsetTop;
    document.onmousemove = function (ev) {
      const oEvent = ev || event;
      dom.style.top = `${oEvent.clientY - shang}px`;
      if (!dom.dataset.blockshuiping) {
        dom.style.left = `${oEvent.clientX - zuo}px`;
      }
      // 左边
      if (dom.offsetLeft < 0) {
        dom.style.left = 0;
      }
      // 右
      if (dom.offsetLeft > document.documentElement.clientWidth - dom.offsetWidth) {
        dom.style.left = `${document.documentElement.clientWidth - dom.offsetWidth}px`;
      }
      // 上
      if (dom.offsetTop < 0) {
        dom.style.top = 0;
      }
      // 下
      if (dom.offsetTop > document.documentElement.clientHeight - dom.offsetHeight) {
        dom.style.top = `${document.documentElement.clientHeight - dom.offsetHeight}px`;
      }
    };
    document.onmouseup = function () {
      document.onmousemove = null;
      dom.onmouseup = null;
    };
    return false;
  };
};

export default drag;
